const resource = `form-datas`

export default function formDatas({ apiClient }) {
  return {
    list(params) {
      return apiClient.get(resource, {}, params)
    },
    show(id) {
      return apiClient.get(`${resource}/${id}`, {}, {})
    },
    export(params) {
      return apiClient.get(`${resource}/export`, {}, params)
    },
  }
}
